/* NewPrime Theme JS — vanilla, no dependencies */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  const formatMoney = (cents) => {
    const fmt = (window.theme && theme.moneyFormat) || '€{{amount_with_comma_separator}}';
    const n = (cents / 100).toFixed(2);
    const [i, d] = n.split('.');
    const withDots = i.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, `${withDots},${d}`)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, i)
      .replace(/\{\{\s*amount\s*\}\}/, `${i.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${d}`);
  };

  const toast = (msg) => {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('is-visible'), 2600);
  };

  /* Reveal on scroll */
  const io = 'IntersectionObserver' in window && new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px' });
  $$('.reveal').forEach((el) => io ? io.observe(el) : el.classList.add('is-in'));

  /* Mobile nav */
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-open]');
    const close = e.target.closest('[data-close]');
    if (open) { e.preventDefault(); $(open.dataset.open)?.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    if (close) { e.preventDefault(); $(close.dataset.close)?.classList.remove('is-open'); document.body.style.overflow = ''; }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { $$('.is-open').forEach((el) => el.classList.remove('is-open')); document.body.style.overflow = ''; }
  });

  /* Desktop mega menu: close other details */
  $$('.header__nav details').forEach((d) => {
    d.addEventListener('toggle', () => { if (d.open) $$('.header__nav details').forEach((o) => o !== d && (o.open = false)); });
  });
  document.addEventListener('click', (e) => { if (!e.target.closest('.header__nav')) $$('.header__nav details[open]').forEach((d) => (d.open = false)); });

  /* Predictive search */
  $$('[data-predictive]').forEach((wrap) => {
    const input = $('input', wrap), box = $('.predictive', wrap);
    let timer;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { box.classList.remove('is-open'); return; }
      timer = setTimeout(async () => {
        try {
          const r = await fetch(`${theme.routes.predictive_search_url}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
          const { resources } = await r.json();
          const items = resources.results.products || [];
          box.innerHTML = items.length
            ? items.map((p) => `<a href="${p.url}"><img src="${p.image || ''}" alt="" loading="lazy" width="48" height="48"><span><strong style="display:block;font-size:.9rem">${p.title}</strong><small class="muted">${formatMoney(Math.round(parseFloat(p.price) * 100))}</small></span></a>`).join('')
            : `<p class="muted" style="padding:.75rem">No results</p>`;
          box.classList.add('is-open');
        } catch (_) {}
      }, 220);
    });
    document.addEventListener('click', (e) => { if (!wrap.contains(e.target)) box.classList.remove('is-open'); });
  });

  /* Sliders */
  $$('[data-slider]').forEach((root) => {
    const track = $('.slider', root);
    $('[data-prev]', root)?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }));
    $('[data-next]', root)?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }));
  });

  /* Tabs */
  $$('[data-tabs]').forEach((root) => {
    const btns = $$('[role=tab]', root);
    btns.forEach((b) => b.addEventListener('click', () => {
      btns.forEach((x) => { x.setAttribute('aria-selected', x === b); $('#' + x.getAttribute('aria-controls')).hidden = x !== b; });
    }));
  });

  /* Countdown */
  $$('[data-countdown]').forEach((el) => {
    const end = new Date(el.dataset.countdown).getTime();
    if (isNaN(end)) return;
    const tick = () => {
      const d = Math.max(0, end - Date.now());
      const v = [Math.floor(d / 864e5), Math.floor(d / 36e5) % 24, Math.floor(d / 6e4) % 60, Math.floor(d / 1e3) % 60];
      $$('b', el).forEach((b, i) => (b.textContent = String(v[i]).padStart(2, '0')));
    };
    tick(); setInterval(tick, 1000);
  });

  /* Quantity steppers */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.qty button[data-step]');
    if (!b) return;
    const input = $('input', b.closest('.qty'));
    input.value = Math.max(+input.min || 0, (+input.value || 0) + +b.dataset.step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------- Cart ------- */
  const drawer = $('#CartDrawer');
  const renderCart = async () => {
    const r = await fetch(`${theme.routes.cart_url}?section_id=cart-drawer-content`);
    const html = await r.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('#CartDrawerContent', doc);
    if (fresh) $('#CartDrawerContent').replaceWith(fresh);
    const count = fresh?.dataset.count ?? '0';
    $$('[data-cart-count]').forEach((c) => { c.textContent = count; c.hidden = count === '0'; });
  };
  const openCart = () => { drawer?.classList.add('is-open'); document.body.style.overflow = 'hidden'; };

  const addToCart = async (form) => {
    const btn = $('[type=submit]', form);
    btn?.setAttribute('disabled', '');
    try {
      const res = await fetch(theme.routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'Error');
      await renderCart();
      drawer ? openCart() : toast(theme.strings.added);
    } catch (err) { toast(err.message); }
    finally { btn?.removeAttribute('disabled'); }
  };
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !drawer) return;
    e.preventDefault(); addToCart(form);
  });

  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (!input) return;
    await fetch(theme.routes.cart_change_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +input.dataset.lineQty, quantity: +input.value }) });
    renderCart();
  });
  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-line-remove]');
    if (!rm) return;
    e.preventDefault();
    await fetch(theme.routes.cart_change_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +rm.dataset.lineRemove, quantity: 0 }) });
    renderCart();
  });

  /* ------- Product page ------- */
  $$('[data-product]').forEach((root) => {
    const json = $('script[data-product-json]', root);
    if (!json) return;
    const product = JSON.parse(json.textContent);
    const form = $('form[action*="/cart/add"]', root);
    const idInput = $('input[name=id]', form);
    const mainImg = $('.pdp__main img', root);

    // Gallery
    $$('.pdp__thumbs button', root).forEach((t) => t.addEventListener('click', () => {
      $$('.pdp__thumbs button', root).forEach((x) => x.setAttribute('aria-current', x === t));
      mainImg.src = t.dataset.src; mainImg.srcset = t.dataset.srcset || ''; mainImg.classList.remove('is-zoomed');
    }));
    mainImg?.addEventListener('click', () => mainImg.classList.toggle('is-zoomed'));

    const update = () => {
      const selected = $$('.option', root).map((f) => $('input:checked', f)?.value);
      const v = product.variants.find((x) => x.options.every((o, i) => o === selected[i]));
      // Mark unavailable combos
      $$('.option', root).forEach((f, idx) => {
        $$('input', f).forEach((inp) => {
          const test = [...selected]; test[idx] = inp.value;
          const match = product.variants.find((x) => x.options.every((o, i) => o === test[i]));
          inp.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
      const btn = $('[type=submit]', form);
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? theme.strings.addToCart : theme.strings.soldOut;
      $$('[data-price]', root).forEach((p) => (p.textContent = formatMoney(v.price)));
      $$('[data-compare]', root).forEach((p) => { p.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : ''; });
      $$('[data-save]', root).forEach((p) => {
        const s = v.compare_at_price > v.price ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0;
        p.hidden = !s; p.textContent = `-${s}%`;
      });
      $$('[data-sku]', root).forEach((p) => (p.textContent = v.sku || '—'));
      if (v.featured_image && mainImg) { mainImg.src = v.featured_image.src; mainImg.removeAttribute('srcset'); }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    root.addEventListener('change', (e) => { if (e.target.closest('.option')) update(); });

    // Sticky ATC
    const sticky = $('.sticky-atc');
    if (sticky && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(form);
      $('button', sticky)?.addEventListener('click', () => form.requestSubmit());
    }
  });

  /* Collection filters: auto-submit */
  $$('[data-filter-form]').forEach((form) => {
    let t;
    form.addEventListener('change', () => { clearTimeout(t); t = setTimeout(() => form.submit(), 350); });
  });
  $$('[data-sort]').forEach((sel) => sel.addEventListener('change', () => {
    const u = new URL(location.href); u.searchParams.set('sort_by', sel.value); location.href = u;
  }));
})();
